import searchComponent from './search.component';
import searchResultItemComponent from './components/searchResultItem/searchResultItem.component';
import searchRoute from './search.routes';

angular.module('rym.search', []).component('rymSearch', searchComponent).component('rymSearchResultItem', searchResultItemComponent).run(searchRoute);
